import { getFlagValue, isFlagEnabled } from '@Redux/actions/flagsmith';
import {
  ADDRESS_INPUT_BLOCKED_WORDS_LIST_FLAGSMITH_KEY,
  REMITTER_ADDRESS_BLACKLIST
} from '@Utils/constants';
import { store } from '../../../../../store';
import get from 'lodash/get';

interface CountryAddressBlockConfig {
  additionalAddressBlock: string[];
}

let cachedList: string[] = [];
let cachedPattern: RegExp | null = null;

// tested on regex101 with ^\s*(NA|N\/A|NULL|NONE|TBD)\s*$
// get the list and make the list a string with | as delimiter and then check
// the regex agains that string
const getValidationPattern = (blockedList: string[]): RegExp => {
  // just shallow comparision
  if (cachedPattern && blockedList === cachedList) return cachedPattern;
  const escaped = blockedList.map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  cachedPattern = new RegExp(`^\\s*(${escaped.join('|')})\\s*$`, 'i');
  cachedList = blockedList;
  return cachedPattern;
};

export const isValidBeneAddressInput = (value: string) => {
  if (!value || typeof value !== 'string') return undefined;
  let blockedList: string[] = [];
  if (isFlagEnabled(ADDRESS_INPUT_BLOCKED_WORDS_LIST_FLAGSMITH_KEY)) {
    const flagsmithValue = getFlagValue(ADDRESS_INPUT_BLOCKED_WORDS_LIST_FLAGSMITH_KEY);
    if (flagsmithValue) blockedList = flagsmithValue;
  }
  const pattern = getValidationPattern(blockedList);
  return pattern.test(value.trim())
    ? 'Please enter a valid address. Placeholder values are not accepted.'
    : undefined;
};

export const getCountryWiseBlacklistWords = (value: string): string | undefined => {
  if (!isFlagEnabled(REMITTER_ADDRESS_BLACKLIST)) return undefined;
  if (!value || typeof value !== 'string') return undefined;
  const countryCode = get(store.getState(), 'rootReducer.userStatusReducer.country_code', '');
  const flagsmithValue: Record<string, CountryAddressBlockConfig> = getFlagValue(
    REMITTER_ADDRESS_BLACKLIST
  );
  if (!flagsmithValue) return undefined;
  const blockedList = flagsmithValue[countryCode]?.additionalAddressBlock ?? [];
  if (blockedList.length === 0) return undefined;

  const pattern = getValidationPattern(blockedList);
  return pattern.test(value.trim())
    ? 'Enter a valid address. Placeholder values are not accepted.'
    : undefined;
};
